<template>
  <img src="@/assets/images/logos/company-logo-iuth.png"/>
</template>
<script setup>
</script>